import { useMemo } from 'react'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { TrendingWidgetsType } from 'components/widget/TrendingWidgets/types'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { convertToTableData } from '../../Table/utils'

const useRowSparklineData = (widgetId: number, selectionName?: string) => {
  const widgetSetting = useDashboardWidgetSetting<TrendingWidgetsType>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)

  const aggregateValues = useMemo(() => convertToTableData(widgetData?.data, widgetSetting), [
    widgetData,
    widgetSetting
  ])
    .find((rowData) => rowData?.name === selectionName)
    ?.aggregateResult?.values?.map(Number)

  return aggregateValues
}

export default useRowSparklineData
